import React, { useContext, useEffect, useState } from "react";
import "./progressbar.css";
import { Link, useLocation } from "react-router-dom";
import { FaUser, FaUsers, FaLock, FaBuilding, FaBars, FaChevronDown, FaChevronUp, FaTiktok, FaVideo } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import CommonLoader from "../../../loader/CommonLoader";
import { LoginContext } from "../../../App";
import { hasPermission } from "../../../helperPermissionEditor";
import { FaUsersGear } from "react-icons/fa6";
import { FaHome } from "react-icons/fa";
import { TbApi } from "react-icons/tb";
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from "react-bootstrap";

const ProgressBar = () => {
  const { user, isSidebarOpen, setIsSidebarOpen } = useContext(LoginContext);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(null);
  const role = localStorage.getItem("userRole");
  const isSuperAdmin = role === "super-admin";
  const isClient = role === "client";

  const handleSelect = (eventKey) => {
    setActiveKey(prev => (prev === eventKey ? null : eventKey));
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const isActive = (path) => location.pathname === path;

  const getLinkClass = (path) => {
    return `link  text-decoration-none ${isActive(path) ? "active-link" : ""}`;
  };

  const activeLinkStyle = {
    backgroundColor: "#f5f5f5",
    color: "#262626",
  };

  useEffect(() => {
    if (window.innerWidth < 576) {
      setIsSidebarOpen(false);
    }
  }, [location]);

  function CustomToggle({ children, activePath, path, icon }) {
    const decoratedOnClick = useAccordionButton(path);
    const isActivePath = isActive(activePath);

    return (
      <Link
        onClick={decoratedOnClick}
        className={getLinkClass(activePath)}
        style={isActivePath ? activeLinkStyle : {}}
      >
        {icon}
        {isSidebarOpen && (
          <div className="w-100 d-flex justify-content-between align-items-center">
            {children}
            {activeKey === path ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        )}
      </Link>
    );
  }

  function SubMenu({ path, label, icon, menus = [] }) {
    const activeMenuPath = menus.find(({ to }) => isActive(to))?.to;
    return (
      <div>
        <CustomToggle activePath={activeMenuPath} path={path} icon={icon}>
          {label}
        </CustomToggle>

        <Accordion.Collapse eventKey={path} className="sub-menu">
          <div>
            {menus?.map(({ to, label, icon, access }) => access !== false && (
              <Link
                key={to}
                to={to}
                className={getLinkClass(to)}
                style={isActive(to) ? activeLinkStyle : {}}
              >
                {icon}
                {isSidebarOpen && label}
              </Link>
            ))}
          </div>
        </Accordion.Collapse>
      </div>
    );
  }

  return (
    <div className={`ProgressBar invisible-md ${isSidebarOpen ? "open" : "collapsed"} pt-3`}>
      <button
        className="toggle-button link text-decoration-none"
        onClick={toggleSidebar}
        id="logoButton"
      >
        <FaBars className="me-2" />
        <p
          style={{ fontSize: "1rem", marginBottom: "0px", fontWeight: 500 }}
        >
          {isSidebarOpen && (process.env.REACT_APP_NAME)}
        </p>
      </button>

      <Link
        className={getLinkClass("/dashboard")}
        to="/dashboard"
        style={isActive("/dashboard") ? activeLinkStyle : {}}
      >
        <FaHome className="me-2" />
        {isSidebarOpen && "Dashboard"}
      </Link>

      <Accordion
        style={{ width: "100%" }}
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        <SubMenu
          path="/tik-tok-services"
          label="TikTok Services"
          icon={<SiTiktok className="me-2" />}
          menus={[
            {
              to: "/tiktokAccounts",
              label: "TikTok Analytics",
              icon: <FaTiktok className="me-2" />,
            },
            {
              to: "/tiktokVideos",
              label: "TikTok Posts",
              icon: <FaVideo className="me-2" />,
            },
            {
              to: "/add-tiktoks",
              label: "TikTok Account Management",
              icon: <FaUsersGear className="me-2" />,
              access: isClient,
            }
          ]}
        />
      </Accordion>

      {hasPermission(user.permissions, "view-user") && (
        <Link
          className={getLinkClass("/userListing")}
          to="/userListing"
          style={isActive("/userListing") ? activeLinkStyle : {}}
        >
          <FaUser className="me-2" />
          {isSidebarOpen && "Users"}
        </Link>
      )}

      {hasPermission(user.permissions, "view-client") && (
        <Link
          className={getLinkClass("/clientListing")}
          to="/clientListing"
          style={isActive("/clientListing") ? activeLinkStyle : {}}
        >
          <FaBuilding className="me-2" />
          {isSidebarOpen && "Clients"}
        </Link>
      )}

      {hasPermission(user.permissions, "view-role") && (
        <Link
          className={getLinkClass("/rolelist")}
          to="/rolelist"
          style={isActive("/rolelist") ? activeLinkStyle : {}}
        >
          <FaUsers className="me-2" />
          {isSidebarOpen && "Roles"}
        </Link>
      )}

      {hasPermission(user.permissions, "view-permission") && (
        <Link
          className={getLinkClass("/permissionlist")}
          to="/permissionlist"
          style={isActive("/permissionlist") ? activeLinkStyle : {}}
        >
          <FaLock className="me-2" />
          {isSidebarOpen && "Permissions"}
        </Link>
      )}

      {hasPermission(user.permissions, "view-daily-api-hit") && (
        <Link
          className={getLinkClass("/totalApiHits")}
          to="/totalApiHits"
          style={isActive("/totalApiHits") ? activeLinkStyle : {}}
        >
          <TbApi className="me-2" />
          {isSidebarOpen && "Total API Hits"}
        </Link>
      )}

      {isLoading && (
        <div className="loader-overlay">
          <CommonLoader />
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
